import { BitrixVue } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';



export const AkciiDetail = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number],
    },
    data(){
        return {
          shareObj: false
        }
      },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH']),
        akciiDetail(){
            let arReturn = {};
            for(let i in this.struct[this.structKey].CHILDS){
                if(this.struct[this.structKey].CHILDS[i].componentData.VUE_COMPONENT == 'AkciiDetail'){
                    arReturn = this.struct[this.structKey].CHILDS[i].componentData.ITEM;
                }
            }
            return arReturn;
        }
    },
    methods: {
        share(e){

            if(this.shareObj == false){
              this.shareObj = Ya.share2($(e.target).find('.ya-share2')[0], {
                theme: {
                  services: 'vkontakte,odnoklassniki,telegram,twitter,whatsapp,pinterest',
                  size: 'm',
                  colorScheme: "whiteblack",
                  popupPosition: 'inner',
                  useLinks: true,
                  direction: 'horizontal'
                },
                content: {
                    url: window.location.origin + this.akciiDetail.DETAIL_PAGE_URL,
                    title: this.akciiDetail.NAME,
                    description: this.akciiDetail.PREVIEW_TEXT,
                    image: window.location.origin + this.akciiDetail.PREVIEW_IMAGE
                }
              });
            }
            let link = $(e.target);
            if(!link.hasClass('is-active')){
                link.addClass('is-active');
                link.find('.js-share-inner').addClass('is-open');
            } else{
                link.removeClass('is-active');
                link.find('.js-share-inner').removeClass('is-open');
            }

        },
    },
    template: `
    <div class="brand__detail brand__detail--promo">
        <div class="brand__detail-top">
            <div  class="brand__detail-logo">
                <div v-if="this.akciiDetail.DATE !== false" class="promo__item-info-leftside">
                    <span>действует до:</span>
                    <div class="promo__item-info-date">
                        <span>{{this.akciiDetail.DATE.day}}</span>
                        {{this.akciiDetail.DATE.month}}
                        <span class="promo__item-info-date-year">‘{{this.akciiDetail.DATE.year}}</span>
                    </div>
                </div>
            </div>
            <div class="brand__detail-desc content" v-html="this.akciiDetail.TEXT"></div>
            <div v-if="this.akciiDetail.IMAGE !== false" class="brand__detail-country">
                <img :src="this.akciiDetail.IMAGE" alt="" title="" loading="lazy">
            </div>
        </div>
        <div class="section__back">
            <a v-if="this.akciiDetail.BACK_BTN" :href="this.akciiDetail.BACK_BTN" class="btn btn--border">
                <svg class="icon icon-arrow-prev"><use xlink:href="#icon-arrow-prev"></use></svg>
                Ко всем акциям
            </a>

            <div class="product-detail__share js-share" @click="share($event)">
                <svg class="icon icon-share"><use xlink:href="#icon-share"></use></svg>
                Поделиться акцией
                <div class="product-detail__share-inner js-share-inner">
                    <div class="ya-share2"></div>
                </div>
            </div>

        </div>
    </div>
    `
}